import { Text } from "@src/components/Text";
import { StyleSheet } from "react-native-unistyles";
import { useAmplitude } from "@src/hooks/useAmplitude";
import { ANALYTICS_EVENTS } from "@src/services/analytics/events";

const CONTACT_URL = "https://www.visioni.com.au/contact";

export function ContactUsButton() {
  const { track } = useAmplitude();

  return (
    <a
      href={CONTACT_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none", cursor: "pointer" }}
      onClick={() => track(ANALYTICS_EVENTS.CONTACT_US_CLICKED)}
    >
      <Text textStyle="sm/regular" textAlign="center" style={styles.secondaryText}>
        Contact Us
      </Text>
    </a>
  );
}

const styles = StyleSheet.create((theme) => ({
  secondaryText: {
    color: theme.colors.interactive.controls.secondary_foreground,
  },
}));
